import Vue from 'vue'
import { configService } from '@/api/config';

export const Params = {
    async InitParams() {

        let jsonBase;

        try {
            let urlBase = await this.requestParam('url-base')
            let Environment = await this.requestParam('env')
            if(urlBase == null) {
                Environment = '0'; //Local
                urlBase = process.env.VUE_APP_BASE_API;
            } 
            jsonBase = {urlBase: urlBase == null ? process.env.VUE_APP_BASE_API : urlBase };
            
            jsonBase = {
                urlBase: urlBase, 
                urlImages: urlBase + 'api-images/',
                Environment: Environment,
            };
            Vue.prototype.$Params = jsonBase;

            let result = await configService.initConfiguration();
            jsonBase = Object.assign(jsonBase, result);	
            
            jsonBase['isMobile'] = document.documentElement.clientWidth<768;

        } catch (e) {
            jsonBase = e.response.data;
        }

        Vue.prototype.$Params = jsonBase;
    },
    requestParam(param) {
        var urlBase = new URL(document.location.href);
        urlBase.searchParams.set('bases', '1');

        var req = new XMLHttpRequest();
        req.open('GET', urlBase.href, false);
        req.send(null);

        return req.getResponseHeader(param);
    }
};
